module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('h2', [_vm._v("Project/Planner Dept")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "type": _vm.step2p1.approved ? 'success' : 'warning',
      "title": (_vm.step2p1.approved ? _vm.step2p1.approvedStatus : 'Pending Approval'),
      "show-icon": "",
      "closable": false
    }
  }, [(_vm.step2p1 && _vm.step2p1.approvedStatus && !_vm.isPending) ? _c('div', [(_vm.step2p1.approved_at) ? _c('p', [_vm._v("on "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.step2p1.approved_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.step2p1.approved_by))])]) : _vm._e(), _vm._v(" "), (_vm.step2p1.state.reSurvey || _vm.step2p1.state.reviseTP) ? _c('p', [_vm._v("Actions Required")]) : _vm._e(), _vm._v(" "), (_vm.step2p1.state.reSurvey) ? _c('p', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Re-survey Required")]) : _vm._e(), _vm._v(" "), (_vm.step2p1.state.reviseTP) ? _c('p', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Revise Technical Propsal")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.step2p1.remarks) ? _c('div', [_c('div', {
    staticClass: "html-remarks"
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s((_vm.step2p1.approvedStatus ? _vm.step2p1.approvedStatus + ' ' : '') + 'Remarks')
    }
  }), _vm._v(" "), (_vm.step2p1.remarks) ? _c('html-input', {
    attrs: {
      "no-form": "",
      "disabled": ""
    },
    model: {
      value: (_vm.step2p1.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step2p1, "remarks", $$v)
      },
      expression: "step2p1.remarks"
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No remarks")])], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Finance Dept")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": _vm.step.legalApproved ? 'success' : 'warning',
      "title": (_vm.step.docType ? _vm.step.docType : 'legal documents') + ' ' + (_vm.step.legalApproved ? 'Approved' : 'Pending Approval'),
      "show-icon": "",
      "closable": false
    }
  }, [(_vm.step.legalApproved && _vm.step3p1.approved) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.step3p1.approved_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.step3p1.approved_by))])]) : _vm._e()])], 1), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-598d7dd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/ApprovalRemarks.vue
// module id = 1581
// module chunks = 0